module.exports = __webpack_public_path__ + "img/home.fix.avatar.773ff0b3.jpeg";